import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import brandLogo from "assets/images/logo/Image_Microsite_Logo_LifeFitness.png";
import PropTypes from "prop-types";

const useIconStyles = makeStyles({
    iconImage: {
        height: '2em'
    }
});

// * Icon for the LF Logo.
export default function LogoIcon(props) {
    const { logo, ...rest } = props;
    const classes = useIconStyles();
    return (
        <div {...rest}>
            <img alt="Life Fitness Logo" src={logo ? logo : brandLogo} className={classes.iconImage} />
        </div>
    );
}

LogoIcon.propTypes = {
    logo: PropTypes.string,
}
